import React from "react";

import { bool } from "prop-types";
import * as i18n from "util/i18n";
import Logo from "./Logo";

const LogoTitle = ({ isDesktop }) => (
    <div className="logo-header">
        {!isDesktop && <Logo inverse />}
        <h1 className="inverse">
            <div
                dangerouslySetInnerHTML={{
                    __html: i18n.get("login.title"),
                }}
            />
        </h1>
    </div>
);

LogoTitle.propTypes = {
    isDesktop: bool,
};

LogoTitle.defaultProps = {
    isDesktop: false,
};

export default LogoTitle;
